import { useDraggable } from "@dnd-kit/core";
import type { DragPayload } from "@/components/shared/DndProvider";

interface DraggableWidgetCardProps {
  widgetId: string;
  dataId: string;
  children: React.ReactNode;
  globalEntries: { area: string; itemId: string; dataId?: string }[];
}

export function DraggableWidgetCard({
  widgetId,
  dataId,
  children,
  globalEntries,
}: DraggableWidgetCardProps) {
  // If this widget is in global selection and there are multiple selected, drag them all
  const selectedWidgets = globalEntries.filter(e => e.area === 'widget' && e.dataId);
  const isInSelection = selectedWidgets.some(e => e.itemId === widgetId);
  
  const payload: DragPayload = isInSelection && selectedWidgets.length > 1
    ? {
        sourceArea: "widget",
        itemIds: selectedWidgets.map(e => e.itemId),
        dataIds: selectedWidgets.map(e => e.dataId!),
      }
    : {
        sourceArea: "widget",
        itemIds: [widgetId],
        dataIds: [dataId],
      };

  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `widget-${widgetId}`,
    data: payload,
  });

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      style={{ opacity: isDragging ? 0.4 : 1 }}
    >
      {children}
    </div>
  );
}
